export default "__VITE_ASSET__6fff68b1__"